<div id="gaugeChart" style="width: 600px; height: 400px;"></div>
